"use client";

import { c as _c } from "react/compiler-runtime";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import { DropLocation } from "@/components/waves/drops/Drop";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ImageScale } from "@/helpers/image.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import Link from "next/link";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import MemeDropTraits from "./MemeDropTraits";
import MemesLeaderboardDropArtistInfo from "./MemesLeaderboardDropArtistInfo";
import MemesLeaderboardDropCard from "./MemesLeaderboardDropCard";
import MemesLeaderboardDropDescription from "./MemesLeaderboardDropDescription";
import MemesLeaderboardDropHeader from "./MemesLeaderboardDropHeader";
import MemesLeaderboardDropVoteSummary from "./MemesLeaderboardDropVoteSummary";
interface MemesLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly location?: DropLocation | undefined;
}
export const MemesLeaderboardDrop: React.FC<MemesLeaderboardDropProps> = t0 => {
  const $ = _c(95);
  const {
    drop,
    onDropClick,
    location: t1
  } = t0;
  const location = t1 === undefined ? DropLocation.WAVE : t1;
  const isMobileScreen = useIsMobileScreen();
  const isTabletOrSmaller = useMediaQuery("(max-width: 1023px)");
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let mediaImageScale = ImageScale.AUTOx800;
  if (isMobileScreen) {
    mediaImageScale = ImageScale.AUTOx450;
  } else {
    if (isTabletOrSmaller) {
      mediaImageScale = ImageScale.AUTOx600;
    }
  }
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  const title = drop.metadata.find(_temp)?.data_value ?? "Artwork Title";
  const description = drop.metadata.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
  let t3;
  if ($[2] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[2] = drop.parts;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const artworkMedia = t3;
  let t4;
  if ($[4] !== drop.top_raters) {
    t4 = drop.top_raters.slice(0, 3);
    $[4] = drop.top_raters;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const firstThreeVoters = t4;
  let t5;
  if ($[6] !== drop || $[7] !== hasTouchScreen || $[8] !== onDropClick) {
    t5 = () => !hasTouchScreen && onDropClick(drop);
    $[6] = drop;
    $[7] = hasTouchScreen;
    $[8] = onDropClick;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop) {
    t6 = <MemesLeaderboardDropArtistInfo drop={drop} />;
    $[10] = drop;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== canDelete || $[13] !== drop || $[14] !== hasTouchScreen) {
    t7 = !hasTouchScreen && <><WaveDropActionsOpen drop={drop} />{canDelete && <WaveDropActionsOptions drop={drop} />}</>;
    $[12] = canDelete;
    $[13] = drop;
    $[14] = hasTouchScreen;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="tw-flex tw-gap-2 tw-text-iron-400">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t6}{t8}</div></div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== title) {
    t10 = <MemesLeaderboardDropHeader title={title} />;
    $[21] = title;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== description) {
    t11 = <MemesLeaderboardDropDescription description={description} />;
    $[23] = description;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t10}{t11}</div></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== artworkMedia || $[29] !== location || $[30] !== mediaImageScale) {
    t13 = artworkMedia && <div className={`tw-flex tw-h-96 tw-justify-center ${location === DropLocation.WAVE ? "tw-bg-iron-950" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} imageScale={mediaImageScale} /></div>;
    $[28] = artworkMedia;
    $[29] = location;
    $[30] = mediaImageScale;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== drop) {
    t14 = <MemeDropTraits drop={drop} />;
    $[32] = drop;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== drop.context_profile_context || $[35] !== drop.raters_count || $[36] !== drop.rating || $[37] !== drop.rating_prediction || $[38] !== drop.wave.voting_credit_type || $[39] !== firstThreeVoters) {
    t15 = <MemesLeaderboardDropVoteSummary current={drop.rating} projected={drop.rating_prediction} creditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={firstThreeVoters} userContext={drop.context_profile_context} />;
    $[34] = drop.context_profile_context;
    $[35] = drop.raters_count;
    $[36] = drop.rating;
    $[37] = drop.rating_prediction;
    $[38] = drop.wave.voting_credit_type;
    $[39] = firstThreeVoters;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== firstThreeVoters) {
    t16 = firstThreeVoters.map(_temp5);
    $[41] = firstThreeVoters;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t16) {
    t17 = <div className="tw-flex tw-items-center -tw-space-x-2">{t16}</div>;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== drop.raters_count) {
    t18 = formatNumberWithCommas(drop.raters_count);
    $[45] = drop.raters_count;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const t19 = drop.raters_count === 1 ? "voter" : "voters";
  let t20;
  if ($[47] !== t19) {
    t20 = <span className="tw-font-normal tw-text-iron-500">{t19}</span>;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t18 || $[50] !== t20) {
    t21 = <span className="tw-text-xs tw-font-bold tw-text-white">{t18}{" "}{t20}</span>;
    $[49] = t18;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t17 || $[53] !== t21) {
    t22 = <div className="tw-flex tw-items-center tw-gap-2 @[700px]:tw-hidden">{t17}{t21}</div>;
    $[52] = t17;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setIsVotingModalOpen(true);
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== drop) {
    t24 = <VotingModalButton drop={drop} onClick={t23} />;
    $[56] = drop;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t22 || $[59] !== t24) {
    t25 = <div className="tw-flex tw-w-full tw-flex-shrink-0 tw-items-center tw-justify-between tw-gap-4 @[700px]:tw-w-auto @[700px]:tw-justify-end" onClick={_temp3}>{t22}{t24}</div>;
    $[58] = t22;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t15 || $[62] !== t25) {
    t26 = <div className="tw-flex tw-flex-col tw-justify-between tw-gap-4 @[700px]:tw-flex-row @[700px]:tw-items-center">{t15}{t25}</div>;
    $[61] = t15;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t14 || $[65] !== t26) {
    t27 = <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4">{t14}{t26}</div>;
    $[64] = t14;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t12 || $[68] !== t13 || $[69] !== t27 || $[70] !== t9) {
    t28 = <div>{t9}{t12}{t13}{t27}</div>;
    $[67] = t12;
    $[68] = t13;
    $[69] = t27;
    $[70] = t9;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== drop || $[73] !== isMobileScreen || $[74] !== isVotingModalOpen) {
    t29 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[72] = drop;
    $[73] = isMobileScreen;
    $[74] = isVotingModalOpen;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  let t30;
  if ($[76] !== drop || $[77] !== t28 || $[78] !== t29) {
    t30 = <MemesLeaderboardDropCard drop={drop}>{t28}{t29}</MemesLeaderboardDropCard>;
    $[76] = drop;
    $[77] = t28;
    $[78] = t29;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== t30 || $[81] !== touchHandlers) {
    t31 = <div {...touchHandlers}>{t30}</div>;
    $[80] = t30;
    $[81] = touchHandlers;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== canDelete || $[84] !== drop || $[85] !== hasTouchScreen || $[86] !== isActive || $[87] !== setIsActive) {
    t32 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[83] = canDelete;
    $[84] = drop;
    $[85] = hasTouchScreen;
    $[86] = isActive;
    $[87] = setIsActive;
    $[88] = t32;
  } else {
    t32 = $[88];
  }
  let t33;
  if ($[89] !== t31 || $[90] !== t32) {
    t33 = <div className="tw-group tw-w-full">{t31}{t32}</div>;
    $[89] = t31;
    $[90] = t32;
    $[91] = t33;
  } else {
    t33 = $[91];
  }
  let t34;
  if ($[92] !== t33 || $[93] !== t5) {
    t34 = <div className="tw-w-full tw-cursor-pointer tw-@container" onClick={t5}>{t33}</div>;
    $[92] = t33;
    $[93] = t5;
    $[94] = t34;
  } else {
    t34 = $[94];
  }
  return t34;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(voter) {
  return <Link key={voter.profile.handle ?? voter.profile.primary_address} href={`/${voter.profile.handle ?? voter.profile.primary_address}`} onClick={_temp4}>{voter.profile.pfp ? <img className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-h-6 tw-w-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link>;
}